// RESONATE_ERROR_BOUNDARY_V1
// Root-level React error boundary. When any child component throws we render
// a minimal recovery UI instead of letting react-dom unmount the tree. This
// keeps the site usable if a lazy-loaded chunk fails or a third-party (PostHog,
// GTM, Meta pixel) blows up mid-mount.
import { Component } from "react";

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    if (typeof window !== "undefined" && window.posthog && window.posthog.capture) {
      try {
        window.posthog.capture("react_error_boundary", {
          message: String(error && error.message),
          stack: info && info.componentStack,
        });
      } catch { /* swallow - reporting must not itself throw */ }
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          data-testid="root-error-fallback"
          className="min-h-screen grid place-items-center bg-[#FAFAFF] px-6 text-center"
        >
          <div className="max-w-[420px]">
            <h1 style={{ fontFamily: "var(--f-serif)" }} className="text-[32px] leading-[1.1] tracking-[-0.03em] text-[#111827] mb-3">
              Something broke here.
            </h1>
            <p className="text-[14px] text-[rgba(17,24,39,0.65)] mb-6">
              Refresh, or head to the homepage. We're notified.
            </p>
            <a
              href="/"
              className="inline-flex items-center gap-2 bg-[#111827] text-white px-5 py-3 rounded-xl font-medium text-[14px]"
            >
              Return home
            </a>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
